import {
  post, put, remove, get, postExcel, getWithParams,
} from '@/services/api.service';

const state = {
  tickets: [],
  totalTickets: 0,
  mainTableHeaders: [
    {
      text: 'Nr karnetu',
      value: 'ticket_number',
    },
    {
      text: 'Nr faktury/paragonu',
      value: 'invoice_number',
    },
    {
      text: 'Imię i nazwisko',
      value: 'ticket_person',
    },
    {
      text: 'Wykorzystano',
      value: 'used',
    },
    {
      text: 'Status',
      value: 'status',
    },
    {
      text: 'Zablokowany',
      value: 'locked',
    },
    {
      text: 'Data wydania',
      value: 'created',
    },
    {
      text: 'Data ważności',
      value: 'expiration_date',
    },
    {
      text: 'Wartość',
      value: 'price',
    },
    {
      text: 'Akcje',
      sortable: false,
      align: 'center',
      value: 'action',
    },
  ],
  realizationsHeaders: [
    {
      text: 'Nr',
      align: 'center',
      value: 'number',
    },
    {
      text: 'Data wykorzystania',
      align: 'center',
      value: 'used_at',
    },
    {
      text: 'Notatka',
      align: 'center',
      value: 'description',
    },
  ],

};

const mutations = {
  setTickets(data, payload) {
    data.tickets = payload.data;
    data.totalTickets = payload.total;
  },
};

const getters = {
  getTicketsList: data => data.tickets,
  getTotalTickets: data => data.totalTickets,
  getMainTableHeaders: data => data.mainTableHeaders,
  getRealizationsHeaders: data => data.realizationsHeaders,
};

const actions = {
  fetchTickets(context, payload) {
    return new Promise((resolve) => {
      getWithParams('/ticket', payload || {})
        .then((response) => {
          context.commit('setTickets', response);
          resolve();
        });
    });
  },
  createTicket(context, payload) {
    return new Promise((resolve, reject) => {
      post('/ticket', payload)
          .then(() => {
            resolve();
          }, () => {
            reject();
          });
    });
  },
  editTicket(context, payload) {
    return new Promise((resolve, reject) => {
      put(`/ticket/${payload.id}`, payload)
          .then(() => {
            resolve();
          }, () => {
            reject();
          });
    });
  },
  fetchTicketDetails(context, payload) {
    return new Promise((resolve) => {
      get(`/ticket/${payload}`)
          .then((response) => {
            resolve(response);
          });
    });
  },
  fetchTicketItems(context, payload) {
    return new Promise((resolve) => {
      get(`/ticket_items/${payload}`)
          .then((response) => {
            resolve(response);
          });
    });
  },
  editTicketItems(context, payload) {
    return new Promise((resolve, reject) => {
      put(`/ticket_items/${payload.id}`, payload)
          .then(() => {
            resolve();
          }, () => {
            reject();
          });
    });
  },
  removeTicket(context, payload) {
    return new Promise((resolve) => {
      remove(`/ticket/${payload.id}`)
        .then(() => {
          context.dispatch('fetchTickets', payload.searchObj);
          resolve();
        });
    });
  },
  fetchTicketsExcel(context, payload) {
    return postExcel('/ticket/export', payload);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
